class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      /* debounce() lives in global.min.js, which layout/theme.liquid loads with data-src on
         every non-collection template - the lazy-loader holds it until the first user
         interaction. This constructor runs at page load, so debounce was undefined and THREW
         here, which meant <search-form> and its subclass <predictive-search> never wired up.
         Together with the .section-header lookup in predictive-search.js, predictive search
         had been dead on every non-collection template since the header rebuild.

         Use the global when present, otherwise an identical local fallback. No dependency on
         script load order. */
      const debounceFn =
        typeof debounce === 'function'
          ? debounce
          : function (fn, wait) {
              let timer;
              return function () {
                const args = arguments;
                clearTimeout(timer);
                timer = setTimeout(() => fn.apply(this, args), wait);
              };
            };
      this.input.addEventListener(
        'input',
        debounceFn((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
